import { MasterLinkParams } from '../../Constant'
import { logEvent } from '../analytics/firAnalytics'
import { ANALYTICS_TAGS } from '../../Constant/analytics'
import { normalizeError } from '../errors/errorHelpers'
import { isBrowserEnvironment } from '../windowHelpers'
import { FIREBASE_CONFIG } from '../../Config/Firebase/config'

const FUNCTION_NAME = 'getUniqueInstallId'

/**
 * Gets the GA4 client_id for BQ user_pseudo_id.
 * Retries up to `maxAttempts` with `delayMs` between attempts.
 */
export const getUniqueInstallId = async (): Promise<string | null> => {
  if (!isBrowserEnvironment()) return null

  const maxAttempts = 5
  const delayMs = 250

  try {
    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      const clientId = await getGaClientIdViaGtag()
      if (clientId) return clientId
      if (attempt < maxAttempts - 1) {
        await new Promise((resolve) => setTimeout(resolve, delayMs))
      }
    }
    return null
  } catch (error) {
    const normalizedError = normalizeError(error)
    console.error(`Error in ${FUNCTION_NAME}:`, normalizedError)
    logEvent(ANALYTICS_TAGS.firebase_transaction_error, {
      function: FUNCTION_NAME,
      error: normalizedError.message,
    })
    return null
  }
}

const getGaClientIdViaGtag = (): Promise<string | null> => {
  return new Promise((resolve) => {
    const measurementId = FIREBASE_CONFIG?.measurementId
    const hasGtag = typeof window !== 'undefined' && typeof window.gtag === 'function'
    if (!hasGtag || !measurementId) {
      resolve(null)
      return
    }
    try {
      window.gtag?.('get', measurementId, 'client_id', (clientId: unknown) => {
        resolve(typeof clientId === 'string' && clientId.length > 0 ? clientId : null)
      })
    } catch {
      resolve(null)
    }
  })
}

export const determineMasterParamsToAdd = (
  mParams: MasterLinkParams | null,
  newUser: boolean
) => {
  if (!mParams) return null
  let linkParams: MasterLinkParams = {}
  if (mParams?.osc) {
    linkParams.osc = mParams.osc
  }
  if (newUser) {
    if (mParams?.pllm_source) {
      linkParams.pllm_source = mParams.pllm_source
    }
    if (mParams?.referrerUserId) {
      linkParams.referrerUserId = mParams.referrerUserId
    }
  }
  return linkParams
}

export const getUserTimeZone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}
